// extracted by mini-css-extract-plugin
module.exports = {"container":"nK9VriSqymmrvlJzm3nBZ","switchActive":"_1gwHRA3uj5VdpbalKtk5zz","switchLabel":"_2d9VSvCcaZ5xdGxjzhkn59"};